import { gql, useQuery } from '@apollo/client'
import validate from './validation'

export default (vars) => {
  const errors = validate(vars)
  if (errors && Object.keys(errors).length) {
    return { loading: false, error: errors, data: {} }
  }

  const { data, error, loading, refetch } = useQuery(
    gql`query($limit: Int) {
    paginatedServices(limit: $limit) {
      hasNext
      hasPrevious
      next
      previous
      totalDocs
      docs {
        id
        name
        topics {
          id
          name
        }
        createdAt
        updatedAt
      }
    }
  }`,
    {
      variables: vars
    }
  )
  return { loading, data: data ? data.paginatedServices : {}, error, refetch }
}
